/* Mobile sheets use the existing Shopify account session and city URLs. */
(function () {
  'use strict';
  const q = selector => document.querySelector(selector);
  const all = selector => Array.from(document.querySelectorAll(selector));
  const account = q('[data-mobile-account]');
  const overlay = q('[data-mobile-sheet-overlay]');
  const nav = q('[data-nav-drawer]');
  if (!account || !overlay) return;
  let active = null, trigger = null, cityPanel = null;
  let previousOverflow = '', previousRootOverflow = '';
  const header = q('.ppt-header');
  const wholesale = q('[data-mobile-wholesale]');
  const headerWholesale = q('.ppt-header__wholesale');
  if (wholesale && headerWholesale) {
    wholesale.href = headerWholesale.href;
    wholesale.querySelector('strong').textContent = headerWholesale.textContent.trim();
  }
  function positionCityPanel() {
    if (cityPanel && header) cityPanel.style.top = Math.round(header.getBoundingClientRect().bottom + 8) + 'px';
  }
  // Follow the search-row transition so the picker stays below the header.
  if (header && typeof ResizeObserver !== 'undefined') new ResizeObserver(positionCityPanel).observe(header);
  // El panel de ciudad cuelga del header, que es sticky: si la página se mueve,
  // se reubica. Con el panel cerrado no hace nada.
  window.addEventListener('scroll', positionCityPanel, { passive: true });
  const inertStates = new Map();
  const isMobile = () => window.matchMedia('(max-width: 1023px)').matches;

  const motions = new Map();
  function stopMotion(el) {
    const motion = motions.get(el);
    if (motion) { motion.onfinish = null; motion.cancel(); motions.delete(el); }
  }
  function animateSheet(el, frames, duration, done) {
    stopMotion(el);
    if (!el.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { done?.(); return; }
    const motion = el.animate(frames, { duration, easing: 'ease-in-out', fill: 'both' });
    motions.set(el, motion);
    motion.onfinish = () => { done?.(); stopMotion(el); };
  }

  function close(restoreFocus = true) {
    if (!active) return;
    const animateClose = active === 'account' && restoreFocus;
    account.setAttribute('inert', '');
    if (animateClose) {
      const transform = getComputedStyle(account).transform;
      animateSheet(account, [{ transform }, { transform: 'translateY(100%)' }], 300, () => { account.hidden = true; });
      animateSheet(overlay, [{ opacity: getComputedStyle(overlay).opacity }, { opacity: 0 }], 300, () => { overlay.hidden = true; });
    } else {
      stopMotion(account); stopMotion(overlay);
      account.hidden = true; overlay.hidden = true;
    }
    if (cityPanel) { cityPanel.remove(); cityPanel = null; }
    document.body.classList.remove('ppt-account-sheet-open', 'ppt-city-sheet-open');
    document.body.style.overflow = previousOverflow;
    document.documentElement.style.overflow = previousRootOverflow;
    inertStates.forEach((state, el) => {
      if (!state.inert) el.removeAttribute('inert');
      if (state.hidden === null) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', state.hidden);
    });
    inertStates.clear();
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    active = null;
    if (restoreFocus && trigger) trigger.focus();
    trigger = null;
  }

  function open(kind, button) {
    close(false);
    stopMotion(account); stopMotion(overlay);
    account.hidden = true;
    if (nav?.classList.contains('is-open')) q('[data-nav-close]')?.click();
    active = kind; trigger = button;
    previousOverflow = document.body.style.overflow;
    previousRootOverflow = document.documentElement.style.overflow;
    // Solo la hoja de cuenta bloquea el scroll. Hacerlo también con el panel de
    // ciudad rompía el selector: overflow:hidden en html y body cambia la caja de
    // scroll, el `position:sticky` del header deja de pegarlo arriba y el header
    // se va a su lugar estático, al principio del documento. Con la página
    // scrolleada eso son cientos de píxeles fuera de la vista, y el panel, que
    // cuelga del header, se iba con él. El panel es un desplegable anclado al
    // header, no una hoja modal: alcanza con que lo siga.
    if (kind === 'account') {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
    document.body.classList.add(kind === 'account' ? 'ppt-account-sheet-open' : 'ppt-city-sheet-open');
    all('#MainContent, .ppt-footer, footer, .ppt-header').forEach(el => {
      if (kind === 'city' && el.matches('.ppt-header')) return;
      inertStates.set(el, { inert: el.hasAttribute('inert'), hidden: el.getAttribute('aria-hidden') });
      el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true');
    });
    overlay.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    if (kind === 'account') {
      account.hidden = false;
      account.removeAttribute('inert');
      animateSheet(account, [{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }], 500);
      animateSheet(overlay, [{ opacity: 0 }, { opacity: 1 }], 150);
      account.querySelector('[data-mobile-sheet-close]')?.focus();
      refreshOrderCount();
    } else {
      const original = button.closest('.ppt-citywrap')?.querySelector('.ppt-citydrop');
      if (!original) { close(); return; }
      cityPanel = original.cloneNode(true);
      cityPanel.className = 'ppt-mobile-city-panel';
      cityPanel.setAttribute('role', 'dialog');
      cityPanel.setAttribute('aria-label', 'Elegí tu ciudad');
      positionCityPanel();
      cityPanel.querySelectorAll('[data-city-select]').forEach(el => {
        el.setAttribute('role', 'radio');
        el.setAttribute('aria-checked', String(el.getAttribute('aria-current') === 'true'));
      });
      document.body.appendChild(cityPanel);
      cityPanel.querySelector('button')?.focus();
    }
  }

  let countRun = 0;
  async function refreshOrderCount() {
    const run = ++countRun;
    const target = q('[data-mobile-order-count]');
    if (!target || !document.body.classList.contains('ppt-authed')) return;
    target.textContent = 'Ver tus pedidos';
    try {
      const response = await fetch('/apps/pluspet/customer/orders', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) return;
      const data = await response.json();
      if (run !== countRun || data.authenticated !== true || !Array.isArray(data.orders)) return;
      const count = data.orders.length;
      // The endpoint returns at most 30 orders, not an all-time total.
      target.textContent = (count === 30 ? '30+' : String(count)) + (count === 1 ? ' pedido' : ' pedidos');
    } catch (_) { /* Keep the navigation link usable if the API is unavailable. */ }
  }

  document.addEventListener('click', event => {
    const accountButton = event.target.closest('[data-mobile-account-toggle]');
    const cityButton = event.target.closest('.ppt-header__city .ppt-citypill[aria-haspopup]');
    if (isMobile() && (accountButton || cityButton)) {
      event.preventDefault(); event.stopImmediatePropagation();
      const kind = accountButton ? 'account' : 'city';
      if (active === kind) close(); else open(kind, accountButton || cityButton);
      return;
    }
    if (event.target.closest('[data-mobile-sheet-close]') || event.target === overlay) { close(); return; }
    if (active && event.target.closest('.ppt-bottomnav, [data-cart-open], [data-nav-open]')) close(false);
    if (event.target.closest('[data-cart-open]') && nav?.classList.contains('is-open')) q('[data-nav-close]')?.click();
    if (active === 'city') {
      const city = event.target.closest('[data-city-select]');
      if (city) {
        // Selecting the current city only dismisses the picker, as in Lovable.
        // In preview/staging its configured URL can point to production.
        if (city.getAttribute('aria-current') === 'true') {
          event.preventDefault(); event.stopImmediatePropagation(); close();
        } else close(false);
      }
    }
    if (active === 'account' && event.target.closest('[data-mobile-account] a')) close(false);
  }, true);

  document.addEventListener('keydown', event => {
    if (!active) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key !== 'Tab') return;
    const panel = active === 'account' ? account : cityPanel;
    const focusable = Array.from(panel.querySelectorAll('a[href], button:not([disabled])')).concat(all('.ppt-bottomnav a, .ppt-bottomnav button'))
      .filter(el => !el.closest('[inert]') && el.getClientRects().length);
    if (!focusable.length) return;
    if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable.at(-1).focus(); }
    else if (!event.shiftKey && document.activeElement === focusable.at(-1)) { event.preventDefault(); focusable[0].focus(); }
  });
  window.addEventListener('resize', () => { if (!isMobile()) close(); });
  if (nav) new MutationObserver(() => {
    const opened = nav.classList.contains('is-open');
    all('[data-nav-open]').forEach(button => button.setAttribute('aria-expanded', String(opened)));
  }).observe(nav, { attributes: true, attributeFilter: ['class'] });
})();
